export default "__VITE_ASSET__zHg_OvOD__"